<template>
<v-container>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-flex xs12 md44 class="my-3">

      <div class="text-xs-center">
        <h2 class="headline">よくある質問</h2>

      </div>



      <template v-for="item in faqs">
       <p> Q. {{item[0]}}</p>
       <p> A. {{item[1]}}</p>
       <v-divider/>
      </template>



    </v-flex>

<div style="text-align: center;">
<div id="sendline-btn" class="line-it-button" data-lang="ja" data-type="share-a" v-bind:data-url="customurl" style="display: none;"></div>
</div>



    </v-flex>
  </v-layout>
</v-container>
</template>


<script>
export default {
  data () {
    return {
      faqs: [
        [
          'チーム統一のユニフォームが無いのですが、参加できますか？',
          '参加可能です。同じ色のTシャツでもOKですし、当大会にてビブをチーム専用でお渡しいたしますので、いつでも清潔です。'
        ],
        [
          '大会の予約はいつからできますか？',
          '大会によって異なるのですが、概ね3か月前から大会当日までとなります。参加チーム枠もありますので、ご連絡ください。'
        ],
        [
          'チーム統一のユニフォームが無いのですが、参加できますか？',
          '参加可能です。同じ色のTシャツでもOKですし、当大会にてビブをチーム専用でお渡しいたしますので、いつでも清潔です。'
        ],
        [
          '当日の持ち物をお教えください。',
          '大会当日は運動できる服装と内履きをご持参ください。当大会ではビブの貸出、ボールの貸出を行っております。ご気軽にご参加ください。'
        ],
        [
          '1チーム何名まで参加できますか？',
          '何名でも可能です。過去に最大で20名で参加されたチームがありました。'
        ],
        [
          '5人以下で参加できますか？',
          'チームにて参加をいただいているのでご遠慮お願いします。ただし、個人参加大会も行っているので、そちらをご検討ください。'
        ],
        [
          '当日、人数が揃わない場合、棄権になってしまいますか？',
          '1名2名の欠員であれば当運営メンバーが代行します。また、大会責任者へご相談いただければ、他チームからの助っ人を募集いたします。'
        ],
        [
          '審判やオフィシャルが出来ないのですが、参加してもいいですか？',
          '審判、オフィシャルは当大会運営部で行います。ご気軽にご参加ください。'
        ],
        [
          'ケガをした時の対応について教えてください。',
          '基本的に怪我は自己責任となります。怪我の責任は一切負いかねます。各自、スポーツ保険に加入されることをお勧めします。'
        ],
        [
          '領収書の発行をお願いできますか？',
          '可能です。当日、お申し出ください。'
        ],
        [
          '同一大会に2チームエントリーしたいのですが、可能でしょうか？',
          '可能です。ただし、皆さんに楽しんでもらうために4チームに同時エントリーはご遠慮いただいております。'
        ],
        [
          'ハーフではなくクオーターで試合はできませんか？',
          '当大会は、多くのチームと試合を行う事で、すべてのチームがエンジョイできる大会を目指しています。クオーター大会も行っていますが、基本はハーフとなります。'
        ],
        [
          '大会の中止はありますか？',
          '当運営部の要因で中止した事はありませんが、交通事情にて予定参加チームが欠席したケースはございます。その場合、予定チーム数の半分以上が欠席の場合、予定とは異なった大会を行わせていただきます。'
        ],
        [
          '学生（20歳以下）が参加できる大会はありますか？',
          '保護者の許可があれば参加可能ですが、代表者様もしくは引率の方は20歳以上とさせてください。'
        ],
        [
          '練習試合を企画しているのですが、協力いただくことは可能でしょうか？',
          'もちろんできる限り協力させていただきますが、ご希望にそぐわない場合もございますので、概要と当大会運営部が行う事をメールにてご連絡ください。'
        ]
      ]
    }
  }
}

</script>

<style>
.ggmap {
position: relative;
padding-bottom: 56.25%;
padding-top: 30px;
height: 0;
overflow: hidden;
}
 
.ggmap iframe,
.ggmap object,
.ggmap embed {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Faq.vue